import * as React from "react";
import NProgress from "nprogress";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { useSelector } from "react-redux";

import Loader from "../atoms/Loader";
import ManageClubTitle from "../molecules/ManageClubTitle";
import { useGetSponsorshipsByClubQuery } from "../../services/wp";
import { format, parse } from "date-fns";
import { StatusPill } from "../atoms/StatusPill";

interface PropsType extends RouteComponentProps {
    id: any;
}

const ManageClubsSponsorshipsBody = (props: PropsType) => {
    const { data, isLoading, error } = useGetSponsorshipsByClubQuery(props.id);

    const { create_sponsorship_form_link } = useSelector(
        (state: any): any => state.options
    );

    React.useEffect(() => {
        if (isLoading) {
            NProgress.start();
        } else {
            NProgress.done();
        }
    }, [isLoading]);

    return (
        <div className="row manage-clubs-sponsorships-body">
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-12">
                        <ManageClubTitle
                            title="Sponsorships"
                            ctaText="Apply for a sponsorship"
                            ctaUrl={create_sponsorship_form_link.url}
                        />
                    </div>
                </div>
                <Loader active={isLoading}>
                    {error ? (
                        "An error has occurred. Please try again."
                    ) : data?.length === 0 ? (
                        "The club does not have any sponsorships."
                    ) : (
                        <div className="manage-clubs-sponsorships-body__list">
                            <div className="manage-clubs-sponsorships-body__list__row-divider" />
                            {data?.map((sponsorship, i) => {
                                const createdOn = sponsorship.created_on
                                    ? parse(
                                          sponsorship.created_on,
                                          "yyyy-MM-dd H:mm:ss",
                                          new Date()
                                      )
                                    : null;

                                const sponsorshipEndDate =
                                    sponsorship.sponsorship_end_date
                                        ? parse(
                                              sponsorship.sponsorship_end_date,
                                              "yyyy-MM-dd H:mm:ss",
                                              new Date()
                                          )
                                        : null;

                                return (
                                    <React.Fragment key={i}>
                                        <div className="manage-clubs-sponsorships-body__list__item__property manage-clubs-sponsorships-body__list__item__description">
                                            <div className="manage-clubs-sponsorships-body__list__item__description__name">
                                                {sponsorship.company_name}
                                            </div>
                                            <div className="manage-clubs-sponsorships-body__list__item__description__type">
                                                {sponsorship.sponsorship_type}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-sponsorships-body__list__item__property manage-clubs-sponsorships-body__list__item__applied">
                                            <div className="manage-clubs-sponsorships-body__list__item__label">
                                                Date applied
                                            </div>
                                            <div className="manage-clubs-sponsorships-body__list__item__value">
                                                {createdOn &&
                                                !isNaN(createdOn.valueOf())
                                                    ? format(
                                                          createdOn,
                                                          "d LLL y"
                                                      )
                                                    : ""}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-sponsorships-body__list__item__property manage-clubs-sponsorships-body__list__item__requested">
                                            <div className="manage-clubs-sponsorships-body__list__item__label">
                                                End Date
                                            </div>
                                            <div className="manage-clubs-sponsorships-body__list__item__value">
                                                {sponsorshipEndDate &&
                                                !isNaN(
                                                    sponsorshipEndDate.valueOf()
                                                )
                                                    ? `${format(
                                                          sponsorshipEndDate,
                                                          "d LLL y"
                                                      )}`
                                                    : ""}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-sponsorships-body__list__item__property manage-clubs-sponsorships-body__list__item__allocated">
                                            <div className="manage-clubs-sponsorships-body__list__item__label">
                                                Value
                                            </div>
                                            <div className="manage-clubs-sponsorships-body__list__item__value">
                                                {sponsorship.amount
                                                    ? `$${sponsorship.amount}`
                                                    : null}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-sponsorships-body__list__item__status">
                                            {sponsorship.status ? (
                                                <StatusPill
                                                    status={sponsorship.status}
                                                />
                                            ) : null}
                                        </div>
                                        <div className="manage-clubs-sponsorships-body__list__row-divider" />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    )}
                </Loader>
            </div>
        </div>
    );
};

ManageClubsSponsorshipsBody.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageClubsSponsorshipsBody);
